// extracted by mini-css-extract-plugin
export var cardGroup = "CustomersSection-module--cardGroup--5bb04";